declare var google: any;
declare var FB: any;
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from '../auth/login.service';
import Swal from 'sweetalert2';
import { DeviceDetectorService } from '../../../services/device-detector.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  person!: FormGroup;
  contentReady: boolean = false;
  loggedIn: boolean = false;
  userEmail!: string;
  userName!: string;
  userInfo: any;
  isMobile: boolean = false;
  isAr: boolean = false;
  constructor(
    private _FormBuilder: FormBuilder,
    private _LoginService: LoginService,
    private _Router: Router,
    private deviceService: DeviceDetectorService,
  ) { }
  password: string = '';
  isPasswordVisible: boolean = false;
  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobileDevice();
    this.isAr = localStorage.getItem("language") == "ar";
    if (localStorage.getItem("token") != null) {
      this.loggedIn = true;
    
       this._Router.navigate(['/fingerprint']);
   
    }
    this.initiate();
  }
  private decodeToken(token: string) {
    return JSON.parse(atob(token.split('.')[1]));
  }

  initiate() {
    this.person = this._FormBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });
  }
  onSubmit() {
    this.contentReady = true;
    this._LoginService.user_login(this.person.value).subscribe({
      next: (res) => {
        console.log(res)
        localStorage.setItem("username", res['user'].last_name)
        localStorage.setItem("userId", res['user'].id)
        this.contentReady = false;
        Swal.fire({
          icon: 'success',
          title: this.isAr ? "اهلا بيك في سيستم احمد الشحات سيستم" : 'Welcome to AS system',
          showConfirmButton: false,
          timer: 1500,
        });
        this._LoginService.setToken(res.token);
 
        this._Router.navigate(['/fingerprint']);
      },
      error: (err) => {
        this.contentReady = false;

        Swal.fire({
          icon: 'error',
          title: this.isAr ? "  البيانات اللي مدخلها فيها حاجة غلط " : 'Wrong Username or Password',
          text: this.isAr ? 'كلم الدعم' : 'you have to contact us',
          confirmButtonText: this.isAr ? 'تمام' : 'ok',
        });

      },
    });
  }

}
